import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://englishexamexercises.com';
export const SITE_NAME = 'English Exam Exercises';
export const DEFAULT_DESCRIPTION = 'Free English lesson plans, teaching materials, and classroom activities for online ESL teachers. Ready-to-use grammar, reading, speaking, vocabulary, and video lessons organized by level and topic. Created by teachers, for teachers.';
export const DEFAULT_LOGO = `${SITE_URL}/Images/logo512-new.webp`;

function getCanonicalUrl() {
  if (typeof window === 'undefined') return SITE_URL;
  const path = window.location.pathname.replace(/\/index\.html$/, '/').replace(/\/+$/, '') || '/';
  return `${SITE_URL}${path}`;
}

export default function SEO({ title, description, name, type, image, schemaType, authorName, publisherName, datePublished, dateModified }) {
  const absoluteImage = image ? (image.startsWith('http') ? image : `${SITE_URL}${image}`) : DEFAULT_LOGO;
  const currentUrl = getCanonicalUrl();
  const metaDescription = description || DEFAULT_DESCRIPTION;

  // Default Article schema
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": schemaType || "Article",
    "headline": title,
    "description": metaDescription,
    "image": absoluteImage,
    "url": currentUrl,
    "author": {
      "@type": "Organization",
      "name": authorName || SITE_NAME
    },
    "publisher": {
      "@type": "Organization",
      "name": publisherName || SITE_NAME,
      "logo": {
        "@type": "ImageObject",
        "url": DEFAULT_LOGO
      }
    },
    "datePublished": datePublished,
    "dateModified": dateModified || datePublished,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": currentUrl
    }
  };

  return (
    <Helmet>
      { /* Standard metadata tags */ }
      <title>{title}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
      <meta name='description' content={metaDescription} />
      <link rel="canonical" href={currentUrl} />
      { /* End standard metadata tags */ }
      { /* Facebook tags */ }
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      { /* End Facebook tags */ }
      { /* Twitter tags */ }
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={absoluteImage} />
      { /* End Twitter tags */ }
      { /* JSON-LD Structured Data */ }
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      { /* End JSON-LD */ }
    </Helmet>
  )
}
